<template>
    <div>
        <card-component class="p-3" title="Confirmar o cadastro">
            <template v-slot:content>
                <div class="row mb-3">
                    <div class="col-12 col-lg-2">
                        <div class="">
                            <label for="cpf" class="form-label">Cpf</label>
                            <input type="text" class="form-control" id="cpf" v-model="cpf"
                                   @change="errors.cpf = ''" @blur="getEmployees" @focus="employeeName = ''">
                            <alert-error-message-component class="p-1" v-if="errors.cpf" :mesage="errors.cpf">
                            </alert-error-message-component>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10 mt-lg-auto mb-lg-1">
                        <span class="fw-bold fs-5">{{ employeeName }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-lg-6">
                        <label for="service" class="form-label">Serviço</label>
                        <v-select class="w-100" name="service" id="service" :options="optServices"
                                  v-model="serviceSelected" @input="errors.service=''">
                        </v-select>
                        <alert-error-message-component class="p-1" v-if="errors.service" :mesage="errors.service">
                        </alert-error-message-component>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mt-3 d-flex justify-content-center">
                        <button type="button" id="btnContinue" class="btn btn-primary" @click="formValidationdation()">
                            {{ btnContinueText }}
                        </button>
                    </div>
                </div>
            </template>
        </card-component>
    </div>
</template>

<script>




export default {
    name: "OrderCustomerEmployeesConfirmResgister",
    props: ['route_services', 'route_customer_employees', 'route_order_cutomer_employees'],
    data() {
        return {
            register: '',
            cpf: '',
            optServices: [],
            serviceSelected: '',
            employeeName: '',
            btnContinueText: 'Continuar',
            errors: {
                'cpf': '',
                'service': ''
            }
        }
    },
    methods: {
        getServices() {
            let urlServices = this.route_services;
            axios.get(urlServices)
                .then(response => {
                    response.data.forEach(s => {
                        this.optServices.push({label: s.name, code: s.id});
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },

        getEmployees() {
          
            if(this.cpf === ''){
                return;
            }
            let urlEmployees = this.route_customer_employees + '/' + this.cpf
            console.log(urlEmployees);
            $('#btnContinue').attr('disabled', true);
            this.btnContinueText = 'Aguarde';
            console.log(urlEmployees);
            axios.get(urlEmployees)
                .then(response => {
                    if (response.data.status === true) {
                        this.employeeName = response.data.data.name;
                        $('#btnContinue').attr('disabled', false);
                        this.btnContinueText = 'Continuar';
                    } else {
                        this.employeeName = '';
                        $('#btnContinue').attr('disabled', false);
                        this.btnContinueText = 'Continuar';
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        formValidationdation() {
            if (this.employeeName === '') {
                this.errors.cpf = 'Cpf não encontrado';
                return false;
            }

            if (this.serviceSelected === '') {
                this.errors.service = 'Selecione um serviço';
                return false;
            }

            //salvar dados em cookies
            this.btnContinueText = 'Aguarde';
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 1000*60*60;
            now.setTime(expireTime)
            document.cookie = 'employee_cpf='+this.cpf+';expires='+now.toUTCString()+';path=/';
            document.cookie = 'employee_name='+this.employeeName+';expires='+now.toUTCString()+';path=/';
            document.cookie = 'employee_service='+this.serviceSelected.code+';expires='+now.toUTCString()+';path=/';
            document.cookie = 'employee_service_name='+this.serviceSelected.label+';expires='+now.toUTCString()+';path=/';
            window.location.href = this.route_order_cutomer_employees;
            console.log('now', this.route_order_cutomer_employees);

        }

    },
    mounted() {
        this.inputOnlyNumbers('#cpf');
        this.getServices();
    }
}
</script>

<style scoped>

</style>
